import app from 'flarum/forum/app';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import extractText from 'flarum/common/utils/extractText';

const NS = 'kellari-swipe-read-confirm.forum.';

/**
 * Flarum 1.8 `forum` compat does not expose `flarum/common/override`; mirror core's `override()` behavior.
 * @param {object} object
 * @param {string} method
 * @param {function} newMethod  (originalBound, ...originalArgs) => returnValue
 */
function overrideMethod(object, method, newMethod) {
  const original = object[method];
  object[method] = function (...args) {
    return newMethod.apply(this, [original.bind(this), ...args]);
  };
  Object.assign(object[method], original);
}

app.initializers.add('kellari-swipe-read-confirm', () => {
  if (!DiscussionListItem) {
    console.error('[kellari-swipe-read-confirm] DiscussionListItem component missing from flarum.core.compat');
    return;
  }

  // Core's `slidable()` touch utility (forum/utils/slidable.js) synthetically clicks this
  // vnode's underlying element on touchend once a swipe passes its threshold, which is the
  // only way to reach this handler — there's no separate desktop/mouse path to gate. Calling
  // `original()` first keeps core's own icon/classList/disabled-state rendering untouched; we
  // only swap the click handler that core wires up.
  overrideMethod(DiscussionListItem.prototype, 'slidableUnderneathView', function (original) {
    const vnode = original();

    if (vnode && vnode.attrs) {
      vnode.attrs.onclick = () => {
        const discussion = this.attrs.discussion;

        if (!discussion.isUnread()) return;
        if (!confirm(extractText(app.translator.trans(NS + 'confirm_mark_as_read')))) return;

        this.markAsRead();
      };
    }

    return vnode;
  });
});
